import React, { useEffect, useState } from "react";
import CameraIcon from "assets/svgIcons/CameraIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useHookstate } from "@hookstate/core";
import {
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const Welcome = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const { getWelcomeAdsData, getDashboardFeatureSetStatus } =
    useSelector((state) => state.commonReducers) || "";
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null
    ) {
      dispatch(COMMON_SERVICES.getWelcomeAdsImageServices(siteId.get()));
    }
  }, [getDashboardFeatureSetStatus, siteId.get()]);

  // Auto-slide functionality
  useEffect(() => {
    if (getWelcomeAdsData?.Images?.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % getWelcomeAdsData.Images.length
        );
      }, 3000); // Change image every 3 seconds

      return () => clearInterval(interval);
    }
  }, [getWelcomeAdsData?.Images?.length]);


  return (
    <div className="h-100"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div className="header" style={{ zIndex: 1, position: "relative" }}>
        <CameraIcon />
        <p style={{ marginLeft: "8px" }}>{t("Welcome_Screen")}</p>
      </div>
      <div className="box-body welcome-screen">
        
        {getWelcomeAdsData?.Images?.length > 0 ? (
          <div className="welcome-carousel">
            <img 
              src={getWelcomeAdsData.Images[currentImageIndex]?.base64data} 
              alt={`welcome-screen-${currentImageIndex + 1}`}
              className="welcome-image"
            />
            
            {/* Image Counter - Only show if more than 1 image */}
            {getWelcomeAdsData.Images.length > 1 && (
              <div className="image-counter">
                {currentImageIndex + 1} / {getWelcomeAdsData.Images.length}
              </div>
            )}
          </div>
        ) : (
          <div className="no-images-message">
            {t("No_images_available")}
          </div>
        )}
        
      </div>
    </div>
  );
};

export default Welcome;
